import React from 'react';
import styled from 'styled-components';
import MaintenanceIllustration from 'components/MaintenanceIllustration';

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

const Illustration = styled.div`
  margin-bottom: 32px;
  height: 400px;
`;

const Explanation = styled.div`
  margin-bottom: 32px;
  max-width: 100ch;
  text-align: center;
`;

const Title = styled.h2`
  margin: 0 0 16px 0;
  font-size: 1.5rem;
  line-height: 1.2;
  color: ${props => props.theme.colors.secondary};
`;

const Paragraph = styled.p`
  margin: 0 0 32px 0;
  font-size: 1.125rem;
  color: ${props => props.theme.colors.black};
  &:last-child {
    margin-bottom: 0;
  }
`;

const ParagraphSecondary = styled(Paragraph)`
  margin: 0 0 4px 0;
  font-size: 1rem;
  line-height: 1.2;
  color: ${props => props.theme.colors.cadetBlue};
`;

const ServerError = () => {
  return (
    <Wrapper>
      <Content>
        <Illustration>
          <MaintenanceIllustration />
        </Illustration>
        <Explanation>
          <Title>Ha ocurrido un error inesperado</Title>
          <Paragraph>
            Lamentamos informarle que hemos experimentado una interrupción del servicio.
          </Paragraph>
          <ParagraphSecondary>
            Estamos trabajando para solucionar el problema lo antes posible.
          </ParagraphSecondary>
          <ParagraphSecondary>
            Mientras tanto, si tiene alguna pregunta o preocupación, no dude en contactar con
            nosotros.
          </ParagraphSecondary>
          <ParagraphSecondary>Gracias por su comprensión y confianza.</ParagraphSecondary>
        </Explanation>
      </Content>
    </Wrapper>
  );
};

ServerError.propTypes = {};

export default ServerError;
